import React from 'react';
import {TailSpin} from 'react-loader-spinner';
import styled from 'styled-components';
import { theme } from '../../../theme/theme';

export const LoaderContainer = styled.div`
  display: flex;
  align-items: center;
`;

/**
 * Loader component
 * @component
 * @returns
 */
export const LoaderSpinner = () => {
  const { first } = theme;

  return (
    <LoaderContainer>
      <TailSpin
        color={ first }
        height={30}
        width={30}
        style={{ margin: "auto" }}
      />
    </LoaderContainer>
  );
};